import React, { useState } from 'react'
import { Router, Switch, Route, Redirect } from 'react-router-dom'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { useSelector } from 'react-redux'
import SignInPage from './pages/auth/sign-in'
import RegisterPage from './pages/auth/register'
import Alert from './components/alert'
import { useEffect } from 'react'
import { AdminRoutes } from './routes/admin'
import {
  isLoading,
} from './redux/components/components-slice'
import { useDispatch } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-daterangepicker/daterangepicker.css'
import PageNotFound from './pages/errors/page-not-found'
import ForgotPasswordPage from './pages/auth/forgot'
import ResetPassword from './pages/auth/reset-password'
import CheckEmailPassword from './pages/auth/check-email'
// import SetPassword from './pages/auth/set-password';
import GuestRoute from './routes/guest'
import VerifyEmail from './pages/auth/verify-email'
import NotFoundRoute from './routes/not-found'
import OnboardingProvider from './components/provider/onboarding'
import history from './routes/history'
import { getPushNotificationToken } from './utils/push-notifications/index'
import Verify2Fa from './pages/auth/verify-token'
import { useUpdateFCMToken } from './redux/user/hook'
import { setWebToken } from './redux/user/user-slice'

const App = () => {
  const { alert } = useSelector((state) => state.componentsSlice)
  const { user } = useSelector((state) => state.userSlice)

  const loading = useSelector(isLoading)
  const dispatch = useDispatch()
  const { mutateAsync: updateFCMToken } = useUpdateFCMToken()

  const [swRegistration, setSwRegistration] = useState(null)

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('SW registered:', registration)
        setSwRegistration(registration)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (!user) return
    if (!swRegistration) return

    const syncFCM = async () => {
      const token = await getPushNotificationToken(swRegistration)
      if (!token) return

      dispatch(setWebToken(token))
      await updateFCMToken({ fcm_token: token })
    }

    syncFCM()
  }, [user, swRegistration])

  return (
    <OnboardingProvider>
      <React.Fragment>
        <div>
          <Router history={history}>
            <Switch>
              <GuestRoute exact path='/' component={SignInPage} />
              <GuestRoute exact path='/register' component={RegisterPage} />
              <GuestRoute exact path='/forgot' component={ForgotPasswordPage} />
              <GuestRoute
                exact
                path='/check-email'
                component={CheckEmailPassword}
              />
              <GuestRoute
                exact
                path='/reset-password/:token'
                component={ResetPassword}
              />

              <GuestRoute
                exact
                path='/verify-email/:token'
                component={VerifyEmail}
              />
              <GuestRoute
                exact
                path='/verify-2fa/:token'
                component={Verify2Fa}
              />
              {AdminRoutes()}
              {/* 
            <AdminRoute /> */}
              <NotFoundRoute path='*' component={PageNotFound} />
            </Switch>
          </Router>
        </div>

        {/* Other components */}
        {alert?.show && <Alert type={alert?.type} message={alert?.message} />}
      </React.Fragment>
    </OnboardingProvider>
  )
}

export default App
